module.exports = __webpack_public_path__ + "img/not-found__bookmarks.87af367f.svg";